var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512",
      maxWidth: 40,
      height: "auto"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.104 44.344h-2.188c-4.087 0-7.565-3.206-7.916-7.299a1 1 0 1 1 1.993-.172c.263 3.067 2.865 5.471 5.923 5.471h2.188a1 1 0 1 1 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.93 26.08c0 .27-.12.54-.32.73L43.06 44.08c-.3.27-.72.34-1.09.18-.36-.16-.6-.52-.6-.92v-6.67H16.99c-2.49 0-4.82.97-6.58 2.74s-2.73 4.12-2.73 6.63c0 5.18 4.18 9.39 9.31 9.39h4.11c.56 0 1 .45 1 1v6.15c0 .56-.44 1-1 1h-4.83c-4.08 0-7.92-1.59-10.8-4.49A15.32 15.32 0 0 1 1 48.23V30.58c0-8.47 6.85-15.37 15.27-15.37h25.1v-6.4c0-.4.24-.76.61-.92.36-.16.78-.09 1.08.18l18.55 17.27c.2.19.32.46.32.74z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.104 57.842a1 1 0 0 1-1-1V43.344a1 1 0 1 1 2 0v13.498a1 1 0 0 1-1 1zM42.374 36.665a1 1 0 0 1-1-1v-8.593a1 1 0 1 1 2 0v8.593a1 1 0 0 1-1 1zM42.374 22.75a1 1 0 0 1-1-1v-5.536a1 1 0 1 1 2 0v5.536a1 1 0 0 1-1 1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.558 92.194H25.541c-2.995 0-5.431-2.448-5.431-5.458V40.552c0-2.155.924-4.209 2.535-5.634a1 1 0 0 1 1.326 1.498 5.524 5.524 0 0 0-1.86 4.136v46.185c0 1.907 1.539 3.458 3.431 3.458h68.017c1.898 0 3.442-1.557 3.442-3.471V38.518c0-1.907-1.539-3.459-3.431-3.459H52.346a1 1 0 1 1 0-2H93.57c2.994 0 5.431 2.449 5.431 5.459v48.206c-.001 3.016-2.442 5.47-5.443 5.47z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.045 82.289a.997.997 0 0 1-.636-.229L65.785 63.4a1 1 0 0 1 1.273-1.543l22.624 18.66a1 1 0 0 1-.637 1.772z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.564 69.291a.994.994 0 0 1-.636-.229l-26.76-22.07a1 1 0 1 1 1.273-1.543l26.122 21.546 28.85-23.792a.999.999 0 1 1 1.271 1.543L60.201 69.062a.995.995 0 0 1-.637.229z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.061 82.301a1 1 0 0 1-.637-1.771l22.635-18.672a1 1 0 0 1 1.273 1.543L30.696 82.072a.992.992 0 0 1-.635.229z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.de74c91e060b31231364730e7477e16f.svg";
export { ForwardRef as ReactComponent };